(function() {
	'use strict';
	angular.module('quantixApp').controller('SidebarController',
			SidebarController);

	SidebarController.$inject = [ '$scope', '$rootScope', '$state', 'renewableEnergyService', 'Auth',
			'Principal', 'GenericService', 'FAM_MODULE', '$window' ,'PortfolioService', 'AuthKeycloak'];

	function SidebarController($scope, $rootScope, $state, renewableEnergyService, Auth, Principal,
			GenericService, FAM_MODULE, $window,PortfolioService, AuthKeycloak) {
		$scope.sectorList = [];
		$scope.AxisDisable = 'N';
		$scope.isGenericFeedPortfolioEnabled = false;
		$scope.flagUserAxis = null;
		$rootScope.activeMenu = "";
		$scope.isAuthenticated = Principal.isAuthenticated;
		$scope.current = $state.current.name;
        $scope.hasAdminRole = false;
		$scope.checkAxisDisableFlag = function() {

			PortfolioService.validateAxisPortfolio().then(function(data) {

			  if(data == true){

				  $scope.AxisDisable = 'Y';
			  }
			  else{
				  $scope.AxisDisable = 'N';
			  }
			  });

	  }

    $scope.checkFeedPortfolioScreenEnable = function() {
        PortfolioService.getIsGenericFeedPortfolioEnabled()
        .then(function(data) {
            $scope.isGenericFeedPortfolioEnabled=data
          });
        $scope.hasAdminRole = AuthKeycloak.authz.hasRealmRole('ROLE_ADMIN')
    }


    $scope.checkFeedPortfolioScreenEnable();

	  $scope.checkAxisDisableFlag();
		GenericService.getUserModuleAccessData().then(function(result) {
			$scope.userModuleAccessData = result;
			if (!$scope.userModuleAccessData[FAM_MODULE]) {

				$scope.flgForFAMUser = false;
			} else {
				$scope.flgForFAMUser = true;
			}

			if (!$scope.userModuleAccessData["FMSM"]) {
				$scope.flgForFMSMUser = false;
			} else {
				$scope.flgForFMSMUser = true;
			}
		});

		$scope.init = function() {

			renewableEnergyService.getSectorList().then(function(data) {

 				angular.forEach(data, function (row) {

                    if (row.isRequired == 'Y') {

                        $scope.sectorList.push(row);



                    }

                });

				//$scope.sectorModel.push($scope.sectorList[0]);
			}, function(errordata) {

			});
		}

		$scope.dropdownMenu = false;
		$scope.dropdownFlag = false;

		// for responsive IR menu
		angular
				.element($window)
				.bind(
						'resize',
						function() {

							var result = document.getElementById("invResearch");
							var wrappedResult = angular.element(result);
							// get invResearch element
							var element = wrappedResult[0];
							var viewportOffset = element
									.getBoundingClientRect();
							if ((viewportOffset.top >= 0)
									&& (viewportOffset.left >= 0)
									&& (viewportOffset.bottom <= window.innerHeight)
									&& (viewportOffset.right <= window.innerWidth && window.innerHeight
											- viewportOffset.bottom >= 40)) {
								$scope.dropdownFlag = false;
							} else {
								if (viewportOffset.bottom - window.innerHeight <= 0) {
									$scope.dropdownFlag = true;
									$scope.dropdownMenu = false;
								} else {
									if (window.innerHeight
											- viewportOffset.bottom >= 40) {
										$scope.dropdownMenu = true;
										$scope.dropdownFlag = false;
									} else {
										$scope.dropdownMenu = true;
										$scope.dropdownFlag = true;
									}
								}
							}
							// manuall $digest required as resize event
							// is outside of angular\
						});

		// console.log($scope.activeMenu);

		// alert("$scope.current "+JSON.stringify($scope.current));
		Principal.identity().then(function(account) {
			$scope.account = account;

		});
		$rootScope.$on("setactiveMenu", function(event, data) {
			//console.log(data);
			$rootScope.activeMenu = data;
		});
		/*
		 * $scope.setactiveMenu = function(activevalue){ $rootScope.activeMenu
		 * =activevalue; }
		 */

		// alert($scope.isAuthenticated);
		$scope.$on('$includeContentLoaded', function() {
			Layout.initSidebar(); // init sidebar
		});

		$scope.sectorSelection = function(event, sectorObj) {
			var hrefPath = "#/";
			if(sectorObj.sectorId == "1" || sectorObj.sectorName == "Roads & Highways") {
				hrefPath += "infrastructureProjects";
			} else if(sectorObj.sectorId == "2" || sectorObj.sectorName == "Renewable Energy") {
				hrefPath +='renewableEnergy';
			} else if(sectorObj.sectorId == "3" || sectorObj.sectorName == "Conventional Power") {
				hrefPath +='infra/#/conventionalPower';
			} else if(sectorObj.sectorId == "4" || sectorObj.sectorName == "Generation Projects Aggregate") {
				hrefPath +='generationProjectsAggregate';
			}
			$rootScope.sectorObj = sectorObj
			$window.location.href = hrefPath;
		}

		$scope.init();
	}

	var myapp = angular.module('app', [ "ui.router" ])
	myapp.config(function($stateProvider, $urlRouterProvider) {

		// For any unmatched url, send to /route1
		$urlRouterProvider.otherwise("/route1")

		$stateProvider.state('home', {
			url : "/home",
			templateUrl : "home.html"
		}).state('home.list', {
			url : "/list",
			templateUrl : "list.html"
		});

	})

})();
